import { registerBlock } from '../../core/registry.js';
import { SpacerCanvas, SpacerInspector } from './Canvas.jsx';

const definition = {
  type: 'spacer',
  schema: {
    defaults: () => ({ height: 32 }),
  },
  capabilities: { isContainer: false },
  ui: {
    Canvas: SpacerCanvas,
    Inspector: SpacerInspector,
    icon: '↕️',
    label: 'Spacer',
    keywords: ['space', 'gap', 'padding', 'height'],
  },
  serialize: (attrs) => {
    const height = attrs.height || 32;
    return `<div style="height:${height}px;"></div>`;
  },
};

registerBlock(definition);
export default definition;
